export default class WarningException extends Error { }
